import { fetchFromDuffelAPI } from "./fetchFromDuffelAPI";

export async function retrieveSeatMapsFromDuffelAPI(
  offer_id: string,
  client_key: string,
) {
  const getSeatMapResponse = await fetchFromDuffelAPI(
    client_key,
    `offers/${offer_id}/seat_maps`,
  );

  return getSeatMapResponse.data;
}
;
import "/Users/igordepaula/.yarn/berry/cache/@sentry-bundler-plugin-core-npm-0.7.2-054e3436fd-10c0.zip/node_modules/@sentry/bundler-plugin-core/sentry-release-injection-file.js";